export default {
    en: {
        names: {
            name: 'name',
            email: 'email',
            reg_code: 'registration code',
            phone: 'phone'
        }
    },
    et: {
        names: {
            name: 'nimi',
            email: 'e-posti aadress',
            reg_code: 'registrikood',
            phone: 'telefoninumber'
        }
    },
    ru: {
        names: {
            name: 'имя',
            email: 'электронная почта',
            reg_code: 'регистрационный номер',
            phone: 'номер телефона'
        }
    }
}